import type { NetworkParams } from './types'

export const match = (_hostname: string): boolean => true
export const compactTracking = true

export const apply = (url: URL, params: NetworkParams): void => {
  if (params.trackingId) {
    if (!params.preserveCampaignParameters) {
      url.searchParams.delete('utm_content')
      url.searchParams.delete('utm_term')
    }
    url.searchParams.set('utm_search', params.trackingId)
    return
  }
  if (params.content && (!params.preserveCampaignParameters || !url.searchParams.has('utm_content'))) {
    url.searchParams.set('utm_content', params.content)
  }
  if (params.term && (!params.preserveCampaignParameters || !url.searchParams.has('utm_term'))) {
    url.searchParams.set('utm_term', params.term)
  }
  url.searchParams.set('utm_search', params.utmSearch)
}
